<template>
    <app-modal :modal-id="modalId" :modal-size="modalSize" :modal-alignment="modalAlignment"
        :modal-body-class="'w-full max-w-full wizard-steps'" @close-modal="closeModal">
	
        <template slot="header">
            <h5 class="modal-title">
                {{ modalTitle }}
            </h5>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close"
                @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
		<app-overlay-loader v-if="preloader" />
		<template slot="body" v-if="!preloader">
			<div class="row" >
				<div class="col-md-12">
					<table class="table-info-student">
						<tr>
							<td>Student ID</td>
							<td>:</td>
							<td style="min-width: 17%;">{{studentData.student_id}}</td>
							<td>School Name</td>
							<td>:</td>
							<td style="min-width: 112px;">{{studentData.school.name}}</td>
							<td>Product Name</td>
							<td>:</td>
							<td>{{studentData.product_name}}</td>
						</tr>
						<tr>
							<td>Student Name</td>
							<td>:</td>
							<td>{{studentData.full_name}}</td>
							<td>School Level</td>
							<td>:</td>
							<td>{{studentData.school_level.name}}</td>
						</tr>
					</table>
				</div>
			</div>
			<hr style="border-top: 2px solid black; font-weight: bold; margin-top: 20px !important;margin-bottom: 10px !important;" />
			<div class="row">
				<div class="col-md-12">
					<app-breadcrumb page-title="Class List" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<table class="table-class-list">
						<tr>
							<th rowspan="2">No</th>
							<th rowspan="2">Teaching Type</th>
							<th rowspan="2">Teacher</th>
							<th colspan="7">Day</th>
						</tr>
						<tr>
							<th style="width: 125px;">Mon</th>
							<th style="width: 125px;">Tue</th>
							<th style="width: 125px;">Wed</th>
							<th style="width: 125px;">Thu</th>
							<th style="width: 125px;">Fri</th>
							<th style="width: 125px;">Sat</th>
							<th style="width: 125px;">Sun</th>
						</tr>
						<tr v-for="(item, index) in classList" :key="item.id">
							<td>{{ index + 1 }}</td>
							<td>{{ item.teaching_type_desc }}</td>
							<td>{{ item.first_name_teacher }} {{ item.last_name_teacher }}</td>
							<td class="text-center">{{ getTimeByDay(item, 1) }}</td>
							<td class="text-center">{{ getTimeByDay(item, 2) }}</td>
							<td class="text-center">{{ getTimeByDay(item, 3) }}</td>
							<td class="text-center">{{ getTimeByDay(item, 4) }}</td>
							<td class="text-center">{{ getTimeByDay(item, 5) }}</td>
							<td class="text-center">{{ getTimeByDay(item, 6) }}</td>
							<td class="text-center">{{ getTimeByDay(item, 7) }}</td>
						</tr>
					</table>
				</div>
			</div>
			<hr style="border-top: 2px solid black; font-weight: bold; margin-top: 20px !important;margin-bottom: 10px !important;" />
			<div class="row">
				<div class="col-md-12">
					<app-breadcrumb page-title="App Submition" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<table class="table-app-submition" :class="{ 'loading-opacity': preloader }">
						<tr>
							<th>Meaning App</th>
							<th>Reading App</th>
							<th>Result</th>
						</tr>
						<tr>
							<td :style="getBackgroundStyle(app_submition?.meaning_app)">
								{{ formatPercent(app_submition?.meaning_app) }}</td>
							<td :style="getBackgroundStyle(app_submition?.reading_app)">
								{{ formatPercent(app_submition?.reading_app) }}</td>
							<td>{{ app_submition?.result ?? '-' }}</td>
						</tr>
					</table>
				</div>
			</div>
			<hr style="border-top: 2px solid black; font-weight: bold; margin-top: 20px !important;margin-bottom: 10px !important;" />
			<div class="row">
				<div class="col-md-12">
					<app-breadcrumb page-title="Report Progress" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<table class="table-app-progress" :class="{ 'loading-opacity': preloader }">
						<tr>
							<th >MA (Total)</th>
							<th >MA (Remaining)</th>
							<th >RA (Main TB+Ext)</th>
							<th >RA (Remaining)</th>
							<th >Done</th>
						</tr>
						<tr>
							<td :style="getBackgroundStyle(report_progress?.meaning?.progress)">
								{{ formatPercent(report_progress?.meaning?.progress) }}</td>

							<td :style="getBackgroundStyle(report_progress?.meaning?.remaining)">
								{{ formatPercent(report_progress?.meaning?.remaining) }}</td>

							<td :style="getBackgroundStyle(report_progress?.reading?.progress)">
								{{ formatPercent(report_progress?.reading?.progress) }}</td>

							<td :style="getBackgroundStyle(report_progress?.reading?.remaining)">
								{{ formatPercent(report_progress?.reading?.remaining) }}</td>
							<td>{{report_progress?.result ?? '-'}}</td>
						</tr>
					</table>
				</div>
			</div>
			<!-- <hr style="border-top: 2px solid black; font-weight: bold; margin-top: 20px !important;margin-bottom: 10px !important;" />
			<div class="row">
				<div class="col-md-12">
					<app-breadcrumb page-title="Conform School" />
				</div>
			</div> -->
		</template>
		
		<template slot="footer" v-if="!preloader">
			<button class="btn btn-success" type="button" @click.prevent="submitContinue">
				<span v-if="loadingContinue" class="w-100">
					<span class="spinner-bounce">
						<span class="bounce1 mr-1"/>
						<span class="bounce2 mr-1"/>
						<span class="bounce3 mr-1"/>
					</span>
				</span>
				<template v-else>Continue</template>
			</button>&nbsp;
			<button class="btn btn-primary" type="button" @click.prevent="showModalMove">
				<span v-if="loadingMove" class="w-100">
					<span class="spinner-bounce">
						<span class="bounce1 mr-1"/>
						<span class="bounce2 mr-1"/>
						<span class="bounce3 mr-1"/>
					</span>
				</span>
				<template v-else>Move</template>
			</button>
		</template>
		<modal-move
			v-if="isModalMoveActive"
			:modal-id="modalIdMove"
			:inputs="inputs"
			@close-modal="closeModalMove"
		/>
    </app-modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import ModalMove from "./ModalMove";


export default {
	name: "StudentProfileFornWizard",
	mixins: [FormMixin, ModalMixin],
    components: {
        'modal-move': ModalMove
    },
	props: {
		modalId: String,
        LeadId: null,
        CourseId: null,
        CourseName: null,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			isModalMoveActive:false,
			modalIdMove:'modal-move',
			course_id: null,
            loadingContinue: false,
            loadingMove: false,
			studentData:[],
			classList:[],
			app_submition:[],
			report_progress:[],
			inputs:{
				lead_id : null,
				course_id : null,
				status : 0,
				note: null
			},
			preloader: true,
			formData:{},
            modalSize: 'fullscreen',
            modalAlignment: 'center',
		};
	},
    computed: {
        modalTitle() {
            return `Student Profile`;
        }
    },
	created() {
	},
	methods: {

        closeModalMove() {
            let m_id = `#modal-move`;
            $(m_id).modal('hide');
            this.isModalMoveActive = false;
        },
		getTimeByDay(classItem, day) {
			if (classItem.day == day) {
    			return classItem.time_start.slice(0,5) + ' - ' + classItem.time_end.slice(0,5);
			}
			return '';
		},
        formatPercent(val) {
            if (val === null || val === undefined || val === '') return '-'
            return val + '%'
        },
		showModalMove(){
			this.isModalMoveActive = true;
		},
        submitContinue() {
			Swal.fire({
				title: "",
				text: "Are you sure you want to continue this student?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Continue",
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {

					Swal.close();

					Swal.fire({
						title: 'Processing...',
						allowOutsideClick: false,
						showConfirmButton: false,
						didOpen: () => Swal.showLoading()
					});
					this.inputs.status = 1;
					this.axiosPatch({
						url: `/transaction/continue-student-by-teacher`,
						data: this.inputs
					})
					.then((response) => {
						Swal.close();

						if (response.data.status === true) {
							
							Swal.fire({
								title: "Success",
								text: "",
								icon: "success",
							}).then(() => {
							});
						} else {
						
							Swal.fire({
								title: "Failed",
								text: response.data.message,
								icon: "error",
							});
						}
					})
					.catch((error) => {
						Swal.close();

						const message = error.response?.data?.message || error.message || "Something went wrong";

						Swal.fire({
							title: "Failed",
							text: message,
							icon: "error",
						});
					});
				}
			});
        },
        submitMove() {
			Swal.fire({
				title: "",
				text: "Are you sure you want to move this student?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Continue",
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.isConfirmed) {

					Swal.close();

					Swal.fire({
						title: 'Processing...',
						allowOutsideClick: false,
						showConfirmButton: false,
						didOpen: () => Swal.showLoading()
					});

					this.inputs.status = 2;
					this.axiosPatch({
						url: `/transaction/move-student-by-teacher`,
						data: this.inputs
					})
					.then((response) => {
						Swal.close();

						if (response.data.status === true) {
							Swal.fire({
								title: "Success",
								text: "",
								icon: "success",
							}).then(() => {
							});
						} else {
						
							Swal.fire({
								title: "Failed",
								text: response.data.message,
								icon: "error",
							});
						}
					})
					.catch((error) => {
						Swal.close();

						const message = error.response?.data?.message || error.message || "Something went wrong";

						Swal.fire({
							title: "Failed",
							text: message,
							icon: "error",
						});
					});
				}
			});
        },
        getBackgroundStyle(val) {
            if (val === null || val === undefined || val === '') return {}

            const number = Number(val)

            if (number >= 90) {
                return { backgroundColor: 'yellow' }
            }
            if (number < 60) {
                return { backgroundColor: '#ffa6a6', color: 'black' }
            }
            if (number < 80) {
                return { backgroundColor: '#aedef6', color: 'black' }
            }
            if (number < 90) {
                return { backgroundColor: '#aaf495', color: 'black' }
            }

            return {}
        },
		
		afterSuccessFromGetEditData(response) {
			this.inputs.lead_id = response.data.data.student.id;
			this.inputs.course_id = response.data.data.course_id;
			this.studentData = response.data.data.student;
			this.app_submition = response.data.data.app_submition;
			this.report_progress = response.data.data.report_progress;
			this.classList = response.data.data.class_list;
			this.preloader = false;
		},
	},
};
</script>

<style scoped>
	.table-class-list{
		margin-bottom: 20px;	
	}
    .table-class-list th{
        text-align: center;
        background: #4466F2;
        color: white;
        padding: 10px;
        border: 1px solid white;
    }
    .table-class-list td{
        text-align: center;
        padding: 10px;
        background: #dbdbdb;
        border: 1px solid white;
    }
	.table-info-student{
		width: 70%;
		margin-bottom: 20px;	
	}
	.table-info-student td{
		text-wrap: nowrap;
		padding-right: 10px;
	}
	
    .table-app-submition th{
        text-align: inherit;
        background: #4466F2;
        color: white;
        padding: 10px;
        border: 1px solid white;
    }
    .table-app-submition td{
        text-align: center;
        padding: 10px;
        background: #dbdbdb;
        border: 1px solid white;
    }
	
    .table-app-progress th{
        text-align: inherit;
        background: #4466F2;
        color: white;
        padding: 10px;
        border: 1px solid white;
    }
    .table-app-progress td{
        text-align: center;
        padding: 10px;
        background: #dbdbdb;
        border: 1px solid white;
    }
    .table-app-progress span{
        font-weight: 400;
        font-size: 12px;
    }
</style>